/**
 * This checks whether the user's organization has advanced time tracking enabled
 */
type AdvancedTTIsEnabledConfig = {
  project?: {
    organization?: {
      timeTrackingEnabled?: boolean | null
    } | null
  } | null
}

export function advancedTTIsEnabled({
  project,
}: AdvancedTTIsEnabledConfig): boolean {
  return project?.organization?.timeTrackingEnabled === true
}

/**
 * This method checks whether the user's organization matches the project's
 */
type UserIsInternalToProjectOrganization = {
  currentUser?: {
    organization?: {
      id?: string | null
    } | null
  } | null
  project?: { organization?: { id: string } | null } | null
}

export function userIsInternalToProjectOrganization(
  config: UserIsInternalToProjectOrganization,
): boolean {
  const { currentUser, project } = config
  return (
    project?.organization?.id !== null &&
    currentUser?.organization?.id === project?.organization?.id
  )
}
